import { render, staticRenderFns } from "./NsAlert.vue?vue&type=template&id=6897490c&scoped=true&"
import script from "./NsAlert.vue?vue&type=script&lang=js&"
export * from "./NsAlert.vue?vue&type=script&lang=js&"
import style0 from "./NsAlert.vue?vue&type=style&index=0&id=6897490c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6897490c",
  null
  
)

export default component.exports